import { useEffect, useState } from "react";
import axios from "axios";
import Hero from "@/components/landing/Hero";
import CustomerExperience from "@/components/landing/CustomerExperience";
import ForBusiness from "@/components/landing/ForBusiness";
import Testimonials from "@/components/landing/Testimonials";
import WaitlistForm from "@/components/landing/WaitlistForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [count, setCount] = useState(null);
  const [spaStyle, setSpaStyle] = useState("warm");
  useEffect(() => {
    axios.get(`${API}/waitlist/count`).then((r) => setCount(r.data.count)).catch(() => {});
    axios.get(`${API}/settings`).then((r) => setSpaStyle(r.data.spa_style)).catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page">
      <Hero count={count} />
      <CustomerExperience spaStyle={spaStyle} />
      <ForBusiness spaStyle={spaStyle} />

      <section id="waitlist" data-testid="waitlist-section" style={{ padding: "140px 64px", scrollMarginTop: 20 }}>
        <Testimonials />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: 72, maxWidth: 1200, margin: "0 auto", alignItems: "start" }}>
          <div>
            <div className="eyebrow">The waitlist</div>
            <h2 className="serif" style={{ fontSize: 64, fontWeight: 500, margin: "12px 0 0", lineHeight: .98 }}>Be first when San Diego opens.</h2>
            <p style={{ fontSize: 16, lineHeight: 1.7, color: "var(--ink-60)", maxWidth: 420, marginTop: 24 }}>
              We're onboarding a small set of spas and guests neighborhood by neighborhood. Early members get their first evening planned on us; early businesses get Marova Business free for launch season.
            </p>
          </div>
          <WaitlistForm onJoined={(d) => !d.already_joined && setCount((c) => (c ?? 0) + 1)} />
        </div>
      </section>

      <footer data-testid="footer" style={{ borderTop: "1px solid var(--ink-06)", padding: "40px 64px", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, color: "var(--ink-40)" }}>
        <span className="wordmark" style={{ fontSize: 28 }}>marova</span>
        <span>Launching first in San Diego · 2026</span>
        <a href="/kit" data-testid="footer-kit" style={{ color: "var(--ink-40)" }}>Production kit</a>
      </footer>
    </div>
  );
}
